import { Helmet } from 'react-helmet-async';

const HardwarePage = () => {
  return (
    <>
      <Helmet>
        <title>AI Hardware - AI News</title>
        <meta name="description" content="Information on AI hardware, including GPUs, TPUs, and cloud services." />
        <meta name="keywords" content="AI hardware, GPUs, TPUs, AI cloud services, machine learning hardware" />
      </Helmet>
      <div className="container mx-auto p-4">
        <header className="my-8 text-center">
          <h1 className="text-4xl font-bold text-gray-100">AI Hardware</h1>
          <p className="text-lg text-gray-300 mt-2">Discover the latest in AI hardware and infrastructure.</p>
        </header>
        
        <section className="text-center">
          <p className="text-xl text-gray-200">Hardware information coming soon!</p>
          <p className="text-md text-gray-400 mt-2">We are currently curating content for this section. Please check back later.</p>
        </section>
      </div>
    </>
  );
};

export default HardwarePage; 